<main id="main-content" tabindex="-1">
  <figure class="utrecht-figure ggc-figure">
    <div style="height: 100px">
      <ggc-map [mapIndex]="'banner-home'"></ggc-map>
      <ggc-layer-brt-achtergrondkaart
        [mapIndex]="'banner-home'"
      ></ggc-layer-brt-achtergrondkaart>
    </div>
  </figure>
  <div class="utrecht-page-body__content">
    <h1 class="nl-heading nl-heading--level-3 ggc-heading">
      Generieke Geo Componenten Home
    </h1>
    <div class="utrecht-alert utrecht-alert--info ggc-alert">
      <div class="utrecht-alert__icon">
        <span class="utrecht-icon" role="presentation" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="tabler-icon tabler-icon-info-circle"
          >
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
            <path d="M12 9h.01"></path>
            <path d="M11 12h1v4h1"></path>
          </svg>
        </span>
      </div>
      <div class="utrecht-alert__content">
        <div class="utrecht-alert__message" role="status">
          <h2 class="nl-heading nl-heading--level-5 ggc-heading">Nieuw</h2>
          <p class="nl-paragraph ggc-paragraph">
            GGC is nu plug & play! Zie
            <a class="nl-link rhc-link" href="#">documentatie</a>
            voor meer informatie.
          </p>
        </div>
      </div>
    </div>

    <div id="welkom-text">
      <h2 class="nl-heading nl-heading--level-4 ggc-heading">Welkom</h2>
      <p class="nl-paragraph ggc-paragraph">
        Welkom op GGC-Home. <br />
        Op GGC-Home vind je alle informatie om aan de slag te gaan met de
        Generieke Geo Componenten. Het doel van de Generieke Geo Componenten is
        om developer-vriendelijke bouwstenen te leveren aan ontwikkelaars, zodat
        deze snel een specifieke kaartviewer kunnen ontwikkelen met de gewenste
        functionaliteit.<br />
        Bovendien zijn deze componenten flexibel configureerbaar,functioneel
        goed uit te breiden en naar eigen smaak te stylen. <br />
        Bekijk <a class="nl-link rhc-link" href="#">dit kaartvoorbeeld</a> met
        alle componenten.
      </p>
    </div>
    <h2 class="nl-heading nl-heading--level-4 ggc-heading">Inhoud</h2>
    <div class="utrecht-column-layout">
      <ul
        role="list"
        class="utrecht-link-list utrecht-link-list--html-ul ggc-link-list"
      >
        <li class="utrecht-link-list__item">
          <a
            href="#"
            class="utrecht-link utrecht-link--html-a utrecht-link-list__link"
          >
            <span class="utrecht-icon" role="presentation" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="tabler-icon tabler-icon-chevron-right"
              >
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </span>
            <span class="utrecht-link-list__link-text"> Introductie </span>
          </a>
        </li>
        <li class="utrecht-link-list__item">
          <a
            href="/example-index"
            class="utrecht-link utrecht-link--html-a utrecht-link-list__link"
          >
            <span class="utrecht-icon" role="presentation" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="tabler-icon tabler-icon-chevron-right"
              >
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </span>
            <span class="utrecht-link-list__link-text">
              Uitleg componenten
            </span>
          </a>
        </li>
        <li class="utrecht-link-list__item">
          <a
            href="/quick-start"
            class="utrecht-link utrecht-link--html-a utrecht-link-list__link"
          >
            <span class="utrecht-icon" role="presentation" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="tabler-icon tabler-icon-chevron-right"
              >
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </span>
            <span class="utrecht-link-list__link-text"> Quick start </span>
          </a>
        </li>
        <li class="utrecht-link-list__item">
          <a
            href="https://docs.kadaster.nl/ggc/ggs-ggc-library/tsdocs/"
            class="utrecht-link utrecht-link--html-a utrecht-link-list__link"
          >
            <span class="utrecht-icon" role="presentation" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="tabler-icon tabler-icon-chevron-right"
              >
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </span>
            <span class="utrecht-link-list__link-text">
              Technische documentatie (TS Docs) </span
            ><span
              class="fa fa-external-link icon-suffix"
              aria-hidden="true"
            ></span>
          </a>
        </li>
        <li class="utrecht-link-list__item">
          <a
            href="https://github.com/kadaster/generieke-geo-componenten"
            class="utrecht-link utrecht-link--html-a utrecht-link-list__link"
          >
            <span class="utrecht-icon" role="presentation" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="tabler-icon tabler-icon-chevron-right"
              >
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </span>
            <span class="utrecht-link-list__link-text"> GitHub </span
            ><span
              class="fa fa-external-link icon-suffix"
              aria-hidden="true"
            ></span>
          </a>
        </li>
        <li class="utrecht-link-list__item">
          <a
            href="https://github.com/kadaster/generieke-geo-componenten/blob/main/ROADMAP.md"
            target="_blank"
            class="utrecht-link utrecht-link--html-a utrecht-link-list__link"
          >
            <span class="utrecht-icon" role="presentation" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="tabler-icon tabler-icon-chevron-right"
              >
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </span>
            <span class="utrecht-link-list__link-text"> Roadmap </span
            ><span
              class="fa fa-external-link icon-suffix"
              aria-hidden="true"
            ></span>
          </a>
        </li>
        <li class="utrecht-link-list__item">
          <a
            href="https://github.com/kadaster/generieke-geo-componenten/releases"
            target="_blank"
            class="utrecht-link utrecht-link--html-a utrecht-link-list__link"
          >
            <span class="utrecht-icon" role="presentation" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="tabler-icon tabler-icon-chevron-right"
              >
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </span>
            <span class="utrecht-link-list__link-text">
              Releases & changelog </span
            ><span
              class="fa fa-external-link icon-suffix"
              aria-hidden="true"
            ></span>
          </a>
        </li>
      </ul>
    </div>
    <div style="background-color: var(--ggc-color-primary-200)">
      <h2
        class="nl-heading nl-heading--level-4 ggc-heading"
        style="padding: 16px"
      >
        Componenten in gebruik
      </h2>
      <div class="card-wrapper">
        <div class="ggc-card-as-link ggc-card-as-link--default card-width">
          <div class="ggc-card-as-link__content">
            <div class="ggc-card-as-link__heading">PDOK-viewer</div>
            <div
              class="ggc-card-as-link__image-container"
              data-testid="ggc-card-as-link__image-container"
            >
              <img
                width="200"
                class="utrecht-img utrecht-img--photo ggc-card-as-link__image"
                src="./assets/pdok-viewer.png"
                alt=""
              />
            </div>
            <div class="ggc-card-as-link__icon"></div>
            <div class="ggc-card-as-link__description">
              Vind geschikte datasets van PDOK.
            </div>
          </div>
          <div class="ggc-card-as-link__footer">
            <div
              class="ggc-card-as-link__link ggc-card-as-link__anchor"
              data-testid="ggc-card-as-link__link"
            >
              <a
                class="nl-link ggc-link"
                href="https://app.pdok.nl/viewer/"
                target="_blank"
                aria-label="PDOK viewer"
              >
                app.pdok.nl/viewer
              </a>
              <span
                class="fa fa-external-link icon-suffix"
                aria-hidden="true"
              ></span>
            </div>
          </div>
        </div>
        <div class="ggc-card-as-link ggc-card-as-link--default card-width">
          <div class="ggc-card-as-link__content">
            <div class="ggc-card-as-link__heading">WOZ waarde loket</div>
            <div
              class="ggc-card-as-link__image-container"
              data-testid="ggc-card-as-link__image-container"
            >
              <img
                width="200"
                class="utrecht-img utrecht-img--photo ggc-card-as-link__image"
                src="./assets/WOZ.png"
                alt=""
              />
            </div>
            <div class="ggc-card-as-link__icon"></div>
            <div class="ggc-card-as-link__description">
              Bekijk de WOZ-waarde van woningen.
            </div>
          </div>
          <div class="ggc-card-as-link__footer">
            <div
              class="ggc-card-as-link__link ggc-card-as-link__anchor"
              data-testid="ggc-card-as-link__link"
            >
              <a
                class="nl-link ggc-link"
                href="https://www.wozwaardeloket.nl"
                target="_blank"
                aria-label="WOZ viewer"
              >
                www.wozwaardeloket.nl </a
              ><span
                class="fa fa-external-link icon-suffix"
                aria-hidden="true"
              ></span>
            </div>
          </div>
        </div>
        <div class="ggc-card-as-link ggc-card-as-link--default card-width">
          <div class="ggc-card-as-link__content">
            <div class="ggc-card-as-link__heading">Kaarten van Nederland</div>
            <div
              class="ggc-card-as-link__image-container"
              data-testid="ggc-card-as-link__image-container"
            >
              <img
                width="200"
                class="utrecht-img utrecht-img--photo ggc-card-as-link__image"
                src="./assets/kvn.png"
                alt=""
              />
            </div>
            <div class="ggc-card-as-link__icon"></div>
            <div class="ggc-card-as-link__description">
              Gebruik de kaarten en luchtfoto's van Nederland.
            </div>
          </div>
          <div class="ggc-card-as-link__footer">
            <div
              class="ggc-card-as-link__link ggc-card-as-link__anchor"
              data-testid="ggc-card-as-link__link"
            >
              <a
                class="nl-link ggc-link"
                href="https://www.kaartenvannederland.nl"
                target="_blank"
                aria-label="Kaarten van Nederland"
              >
                www.kaartenvannederland.nl </a
              ><span
                class="fa fa-external-link icon-suffix"
                aria-hidden="true"
              ></span>
            </div>
          </div>
        </div>
        <div class="ggc-card-as-link ggc-card-as-link--default card-width">
          <div class="ggc-card-as-link__content">
            <div class="ggc-card-as-link__heading">Verbeter de Kaart</div>
            <div
              class="ggc-card-as-link__image-container"
              data-testid="ggc-card-as-link__image-container"
            >
              <img
                width="200"
                class="utrecht-img utrecht-img--photo ggc-card-as-link__image"
                src="./assets/verbeterdekaart.png"
                alt=""
              />
            </div>
            <div class="ggc-card-as-link__icon"></div>
            <div class="ggc-card-as-link__description">
              Meld verbeteringen op de kaart.
            </div>
          </div>
          <div class="ggc-card-as-link__footer">
            <div
              class="ggc-card-as-link__link ggc-card-as-link__anchor"
              data-testid="ggc-card-as-link__link"
            >
              <a
                class="nl-link ggc-link"
                href="https://www.verbeterdekaart.nl"
                target="_blank"
                aria-label="Verbeter de Kaart"
              >
                www.verbeterdekaart.nl </a
              ><span
                class="fa fa-external-link icon-suffix"
                aria-hidden="true"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
</main>
